"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const material_1 = require("@mui/material");
const IconComponent_1 = tslib_1.__importDefault(require("../IconComponent"));
const ArgusMenuComponentSwitch_1 = tslib_1.__importDefault(require("./ArgusMenuComponentSwitch"));
const StyledComponents_1 = require("./StyledComponents");
const ArgusMenuGroup = ({ items, iconId, label, open, ...rest }) => {
    // Group contain no items, remove group
    if (items?.length === 0)
        return null;
    // If group only have one item, only render that item, keep icon group.
    if (items?.length === 1)
        return react_1.default.createElement(ArgusMenuComponentSwitch_1.default, { ...{ items: [{ ...items[0], iconId }], open } });
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledComponents_1.ListItem, { ...rest.ListItemProps },
            react_1.default.createElement(StyledComponents_1.ListItemButton, { disableRipple: !open, onClick: () => {
                    if (open) {
                        setExpanded((v) => !v);
                    }
                } },
                react_1.default.createElement(StyledComponents_1.ListItemIcon, { ...rest.ListItemIconProps },
                    react_1.default.createElement(IconComponent_1.default, { ...{ iconId, fontSize: "small" } })),
                react_1.default.createElement(StyledComponents_1.ListItemText, { ...{
                        open,
                        primary: label,
                        inset: Boolean(!iconId),
                        primaryTypographyProps: { variant: "body1" },
                        ...rest.ListItemTextProps,
                    } }),
                react_1.default.createElement(StyledComponents_1.ListItemIcon, { sx: { pr: 1, opacity: !open && 0 }, ...rest.ListItemIconProps },
                    react_1.default.createElement(IconComponent_1.default, { ...{ iconId: expanded ? "expandLess" : "expandMore", fontSize: "small" } })))),
        react_1.default.createElement(material_1.Collapse, { in: expanded && open, timeout: "auto", unmountOnExit: true },
            react_1.default.createElement(material_1.List, { component: "div", disablePadding: true },
                react_1.default.createElement(ArgusMenuComponentSwitch_1.default, { ...{ open, items } })))));
};
exports.default = ArgusMenuGroup;
